<style></style>

<template>

    <v-card>

        <v-card-text>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md6>
                        <v-card class="elevation-12">

                            <!-- Card / Cabeçalho -->
                            <v-card-title>
                                <div class="headline">Importação de Bancas</div>
                            </v-card-title>

                            <!-- Card / Conteúdo -->
                            <v-card-text>
                                <div xs6>
                                    <a href="https://minha.unifebe.edu.br/documentos/modelo-importacao-bancas.csv">
                                        <img src="https://minha.unifebe.edu.br/images/arquivo-csv.png" width="50"
                                            alt="">
                                        Baixe aqui o modelo.
                                    </a>
                                </div>

                                <v-form>
                                    <v-select v-model="course" @change="getExamTypes($event)" item-text="name"
                                        item-value="id" label="Curso" prepend-icon="class" data-vv-as="Curso"
                                        data-vv-name="course" v-validate="'required'"
                                        :errors="vErrors.collect('examCourse')" :items="courses" autocomplete
                                        required></v-select>

                                    <v-select v-model="examType" item-text="name" item-value="id" label="Tipo"
                                        prepend-icon="create" data-vv-as="Tipo" data-vv-name="examType"
                                        v-validate="'required'" :errors="vErrors.collect('examType')" :items="examTypes"
                                        required></v-select>

                                    <!-- type[file] não aceita v-model -->
                                    <input type="file" @change="onFileChange" v-show="switchAux">
                                </v-form>
                            </v-card-text>

                            <!-- Card / Rodapé -->
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" v-show="switchAux" @click='fileImport'>Verificar</v-btn>
                            </v-card-actions>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>

        <v-card-text v-show="tableValues.length">
            <v-container>
                <h6>Dados do arquivo</h6>
                <v-data-table :headers="tableHeader" :items="tableValues" class="elevation-1">
                    <template slot="items" slot-scope="props">
                        <td>
                            <input type="checkbox" @click="addOpcaoCheck($event, props.item.ckbx)" />
                        </td>
                        <td>{{ props.item.student.join(', ') }}</td>
                        <td>{{ props.item.title }}</td>
                        <td>{{ props.item.topic }}</td>
                        <td class="text-xs-right">{{ props.item.semesters }}</td>
                        <td class="text-xs-right">{{ props.item.date }}</td>
                        <td class="text-xs-right">{{ props.item.hour }}</td>
                        <td>{{ props.item.place }}</td>
                        <td>{{ props.item.chair }}</td>
                        <td>{{ props.item.advisor }}</td>
                        <td class="text-xs-right">{{ props.item.examiners.join(', ') }}</td>
                        <td>{{ props.item.substitutes }}</td>
                        <td>{{ props.item.notes }}</td>
                        <td class="text-xs-right">{{ props.item.finalScore }}</td>
                        <td class="text-xs-right">{{ props.item.id }}</td>
                        <td>{{ props.item.situation }}</td>
                        <td>{{ props.item.obs_of_situation }}</td>
                        <td class="text-xs-right">{{ props.item.externalNote }}</td>
                    </template>
                    <template slot="no-data">
                        <v-alert :value="true" color="warning" icon="warning">
                            Aguardando a importação dos dados.
                        </v-alert>
                    </template>
                </v-data-table>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-show="switchAux" @click='gerarLoteBancas'>Importar</v-btn>
                </v-card-actions>

                <!-- Alerta de Atenção -->
                <v-alert :value="true" type="warning" v-if="msgWarning.length">
                    {{ msgWarning }}
                </v-alert>

                <!-- Alerta de Erro -->
                <v-alert v-if="msgErrors.length" :value="true" type="error">
                    <v-alert v-for="e in msgErrors" :key="e.id">
                        <ul>
                            <h6>Item: {{ e.registro }}</h6>
                            <li v-for="(value, index) in e.data" :key="index">{{ value }}</li>
                        </ul>
                    </v-alert>
                </v-alert>

                <!-- Alerta de Sucesso -->
                <v-alert v-if="idBancas.length" :value="true" type="success">
                    <v-alert v-for="e in idBancas" :key="e.id">
                        <h6>Item: {{ e.registro }}</h6>
                        <p>Banca Importadas com sucesso.</p>
                        <p>Banca Nº <b>{{ e.data.id }}</b></p>
                    </v-alert>
                </v-alert>
            </v-container>
        </v-card-text>
    </v-card>

</template>

<script>

import {
    noData, noResult, rowsPerPageT
}
    from './../locale/vuetify'
import Events from '../events'
import AutoComplete from './forms/AutoComplete'

export default {
    name: 'ExamImport',
    components: {},
    data() {
        return {
            msgWarning: '',
            msgErrors: [],
            idBancas: [],
            courses: [],
            examTypes: [],
            teachers: [],
            fileBancas: null,
            course: false,
            examType: false,
            opcaoCheck: [],
            switchAux: false,
            tableHeader: [{
                text: 'Marque',
                value: 'ckbx'
            }, {
                text: 'Estudante',
                value: 'student'
            }, {
                text: 'Título',
                value: 'title'
            }, {
                text: 'Tema',
                value: 'topic'
            }, {
                text: 'Semestre',
                value: 'semesters'
            }, {
                text: 'Data',
                value: 'date'
            }, {
                text: 'Hora',
                value: 'hour'
            }, {
                text: 'Local',
                value: 'place'
            }, {
                text: 'Presidente',
                value: 'chair'
            }, {
                text: 'Orientador',
                value: 'advisor'
            }, {
                text: 'Examinadores',
                value: 'examiners'
            }, {
                text: 'Substituto',
                value: 'substitutes'
            }, {
                text: 'Recomendações',
                value: 'notes'
            }, {
                text: 'Nota Final',
                value: 'finalScore'
            }, {
                text: 'ID',
                value: 'id'
            }, {
                text: 'Situação',
                value: 'situation'
            }, {
                text: 'Obs. Situação',
                value: 'obs_of_situation'
            }, {
                text: 'Nota Externa',
                value: 'externalNote'
            }],
            tableValues: []
        }
    },
    methods: {
        watchSwitchAux() {
            this.switchAux = (this.course && this.examType) ? true : false;
        },
        getExamTypes(cursoId) {
            // Load exam types
            this.$http.post('examTypes', {
                limit: 99999,
                curso: cursoId
            }).then(response => {
                this.examTypes = JSON.parse(response.bodyText);
            }, response => {
                console.error('Erro ao buscar relação de tipos de banca.')
                console.debug(response)
            });
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(files[0]);
        },
        createImage(file) {
            var that = this;
            var reader = new FileReader();

            reader.onload = (e) => {
                that.fileBancas = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        fileImport: function (e) {

            let that = this;
            let params = { fileImport: this.fileBancas }

            this.$http.put('bancasImport', params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                that.tableValues = JSON.parse(response.bodyText);
            }, response => {
                console.error('Erro ao submeter os dados para o servidor.');
            })
        },
        addOpcaoCheck(ev, handle) {
            let isChecked = ev.target.checked;

            if (isChecked) {
                if (this.opcaoCheck.indexOf(handle) < 0) {
                    this.opcaoCheck.push(handle);
                }
            } else {
                this.opcaoCheck = this.opcaoCheck.filter(function (val) {
                    return val != handle;
                });
            }
            this.opcaoCheck = this.opcaoCheck.sort();
        },
        gerarLoteBancas() {
            let that = this;

            this.msgWarning = '';
            this.msgWarning = [];

            this.$http.post('bancasGenerateLote', {
                course: this.course,
                examType: this.examType,
                opcaoCheck: this.opcaoCheck,
                fileImport: this.fileBancas
            }, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                console.log(response.body);

                if (response.body.length < 1) {
                    that.msgWarning = "É necessário selecionar ao menos um item para a importação.";
                }

                that.msgErrors = [];
                let itens = response.body;

                for (let item of itens) {
                    if (item.status == 'success') {
                        that.idBancas.push(item);
                    } else {
                        that.msgErrors.push(item);
                    }
                }
            }, response => {
                console.log('erro!', response);
            })
        }
    },
    created: function () {
        // Load courses
        this.$http.get('courses').then(response => {
            this.courses = response.body
        }, response => {
            console.error('Erro ao buscar relação de cursos.')
            console.debug(response)
        });

        // Load teachers
        this.$http.post('teachers', {
            limit: 99999
        }).then(response => {
            this.teachers = response.body
        }, response => {
            console.error('Erro ao buscar relação de professores.')
            console.debug(response)
        });
    },
    watch: {
        course() {
            this.watchSwitchAux();
        },
        examType() {
            this.watchSwitchAux();
        }
    }
}

</script>



// WEBPACK FOOTER //
// ExamImport.vue?377fd286